import React from "react";

const DeleteIcon = () => {
    return (
        <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5253 4.85986H2.01233V6.90661C2.71882 6.90661 3.29155 7.47934 3.29155 8.18583V10.6163C3.29155 11.9269 3.29155 12.5821 3.48832 13.1049C3.79975 13.9324 4.45277 14.5854 5.28022 14.8968C5.80304 15.0936 6.4583 15.0936 7.76881 15.0936C9.07932 15.0936 9.73457 15.0936 10.2574 14.8968C11.0848 14.5854 11.7379 13.9324 12.0493 13.1049C12.2461 12.5821 12.2461 11.9269 12.2461 10.6163V8.18583C12.2461 7.47934 12.8188 6.90661 13.5253 6.90661V4.85986ZM7.19316 8.27114C7.19316 7.70595 6.73498 7.24777 6.16979 7.24777C5.60459 7.24777 5.14641 7.70595 5.14641 8.27114V11.6824C5.14641 12.2476 5.60459 12.7058 6.16979 12.7058C6.73498 12.7058 7.19316 12.2476 7.19316 11.6824V8.27114ZM10.3912 8.27114C10.3912 7.70595 9.93303 7.24777 9.36783 7.24777C8.80264 7.24777 8.34446 7.70595 8.34446 8.27114V11.6824C8.34446 12.2476 8.80264 12.7058 9.36783 12.7058C9.93303 12.7058 10.3912 12.2476 10.3912 11.6824V8.27114Z"
                fill="white"
            />
            <path
                d="M6.53319 3.06595C6.60607 2.99341 6.76667 2.92932 6.99008 2.8836C7.21349 2.83789 7.48722 2.81311 7.76882 2.81311C8.05042 2.81311 8.32415 2.83789 8.54756 2.8836C8.77096 2.92932 8.93156 2.99341 9.00445 3.06595"
                stroke="white"
                strokeWidth="2.04675"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default DeleteIcon;
